module.exports = __webpack_public_path__ + "img/logo_bar@3x.ad1a6897.png";